{
  "INBOX_MGMT": {
    "HEADER": "Boîtes de réception",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Reconnecter",
      "FACEBOOK": "La connexion à Facebook a expiré ou a été révoquée. Les messages envoyés à la page n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Une personne qui gère la page Facebook doit cliquer sur Reconnecter et se connecter à Facebook.",
      "INSTAGRAM": "La connexion à Instagram a expiré ou a été révoquée. Les messages envoyés au compte n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Cliquez sur Reconnecter et connectez-vous au même compte Instagram. Un autre compte crée une nouvelle boîte de réception.",
      "GOOGLE": "La connexion à Google a expiré ou a été révoquée. Les nouveaux e-mails n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Cliquez sur Reconnecter et connectez-vous à Google avec {email}.",
      "MICROSOFT": "La connexion à Microsoft a expiré ou a été révoquée. Les nouveaux e-mails n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Cliquez sur Reconnecter et connectez-vous à Microsoft avec {email}.",
      "ALLEGRO": "La connexion à Allegro a expiré ou a été révoquée. Les messages des acheteurs n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Cliquez sur Reconnecter et connectez-vous à Allegro en tant que vendeur {seller}. Un autre compte vendeur crée une nouvelle boîte de réception.",
      "IMAP_LOGIN": "Le serveur de messagerie refuse la connexion IMAP {login}. Les nouveaux e-mails n'arrivent pas dans cette boîte de réception. Vérifiez l'identifiant et le mot de passe IMAP dans l'onglet {tab}, puis enregistrez-les. Nous continuons à essayer de nous connecter, et la boîte se rétablira dès que la connexion fonctionnera.",
      "WHATSAPP": "La connexion à WhatsApp a expiré ou a été révoquée. Les pièces jointes des clients n'arrivent pas dans cette boîte de réception, et les réponses peuvent échouer. Cliquez sur Reconnecter, connectez-vous à Facebook et sélectionnez de nouveau le numéro {phone}."
    },
    "LIST": {
      "404": "Il n'y a aucune boîte de réception associée à ce compte.",
      "RECONNECT_REQUIRED": "Reconnexion nécessaire"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choisir un canal",
        "BODY": "Choisissez le fournisseur que vous souhaitez intégrer au chat."
      },
      "INBOX": {
        "TITLE": "Créer une boîte de réception",
        "BODY": "Authentifiez votre compte et créez une boîte de réception."
      },
      "AGENT": {
        "TITLE": "Ajouter des agents",
        "BODY": "Ajouter des agents à la boîte de réception créée."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Vous êtes paré !"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nom de la boîte de réception",
        "PLACEHOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)",
        "ERROR": "Veuillez entrer un nom de compte valide"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nom du site web",
        "PLACEHOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nom interne",
        "PLACEHOLDER": "Nommez la boîte de réception telle qu'elle apparaît dans ce tableau de bord",
        "ERROR": "Veuillez entrer un nom interne unique"
      },
      "FB": {
        "HELP": "PS : En vous connectant, nous avons seulement accès aux messages de votre page. Vos messages privés ne peuvent jamais être consultés par nous.",
        "CHOOSE_PAGE": "Choisir la page",
        "CHOOSE_PLACEHOLDER": "Sélectionnez une page dans la liste",
        "INBOX_NAME": "Nom de la boîte de réception",
        "ADD_NAME": "Ajouter un nom pour votre boîte de réception",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Choisir une valeur",
        "CREATE_INBOX": "Créer la boîte de réception"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continuer avec Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connectez votre profil Instagram",
        "HELP": "Pour ajouter votre profil Instagram en tant que canal, vous devez authentifier votre profil Instagram en cliquant sur « Continuer avec Instagram » ",
        "ERROR_MESSAGE": "Une erreur s'est produite lors de la connexion à Instagram, veuillez réessayer",
        "ERROR_AUTH": "Une erreur s'est produite lors de la connexion à Instagram, veuillez réessayer",
        "NEW_INBOX_SUGGESTION": "Ce compte Instagram était précédemment lié à une autre boîte de réception et a été migré ici. Tous les nouveaux messages apparaîtront ici. L'ancienne boîte de réception ne pourra plus envoyer ni recevoir de messages pour ce compte.",
        "DUPLICATE_INBOX_BANNER": "Ce compte Instagram a été migré vers la nouvelle boîte de réception du canal Instagram. Vous ne pourrez plus envoyer/recevoir de messages Instagram depuis cette boîte de réception."
      },
      "TWITTER": {
        "HELP": "Pour ajouter votre profil Twitter en tant que canal, vous devez lier votre profil Twitter en cliquant sur 'Se connecter avec Twitter' ",
        "ERROR_MESSAGE": "Une erreur s'est produite lors de la connexion à Twitter, veuillez réessayer",
        "TWEETS": {
          "ENABLE": "Créer des conversations à partir de Tweets mentionnés"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal site Web",
        "DESC": "Créez un canal pour votre site Web et commencez à assister vos clients à l'aide de notre widget de site Web.",
        "LOADING_MESSAGE": "Création du canal de support du site Web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar du canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL du Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Veuillez entrer une URL valide"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domaine du site Web",
          "PLACEHOLDER": "Entrez le domaine de votre site Web (ex : acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Titre de Bienvenue",
          "PLACEHOLDER": "Salut !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Slogan d'accueil",
          "PLACEHOLDER": "C'est simple de rentrer en contact avec nous. Demandez-nous quoi que ce soit ou partagez vos commentaires."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Message d'accueil du canal",
          "PLACEHOLDER": "Acme Inc répond en général en quelques heures."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Activer l'accueil du canal",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Activé",
          "DISABLED": "Désactivé"
        },
        "REPLY_TIME": {
          "TITLE": "Définir le temps de réponse",
          "IN_A_FEW_MINUTES": "En quelques minutes",
          "IN_A_FEW_HOURS": "En quelques heures",
          "IN_A_DAY": "En une journée",
          "HELP_TEXT": "Ce temps de réponse sera affichée sur le widget de chat en direct"
        },
        "WIDGET_COLOR": {
          "LABEL": "Couleur du Widget",
          "PLACEHOLDER": "Mettre à jour la couleur utilisée dans le widget"
        },
        "SUBMIT_BUTTON": "Créer une boîte de réception",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu créer un canal web, veuillez réessayer"
        }
      },
      "TWILIO": {
        "TITLE": "Chaîne Twilio SMS/WhatsApp",
        "DESC": "Intégrez Twilio et commencez à soutenir vos clients par SMS ou WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID du compte",
          "PLACEHOLDER": "Veuillez entrer le SID de votre compte Twilio",
          "ERROR": "Ce champ est requis"
        },
        "API_KEY": {
          "USE_API_KEY": "Utiliser l'authentification par clé API",
          "LABEL": "SID de la clé API",
          "PLACEHOLDER": "Veuillez entrer votre clé API SID",
          "ERROR": "Ce champ est requis"
        },
        "API_KEY_SECRET": {
          "LABEL": "Secret de la clé API",
          "PLACEHOLDER": "Veuillez entrer le secret de votre clé API",
          "ERROR": "Ce champ est requis"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID du service de messagerie",
          "PLACEHOLDER": "Veuillez entrer votre SID du service de messagerie Twilio",
          "ERROR": "Ce champ est requis",
          "USE_MESSAGING_SERVICE": "Utilisez un service de messagerie Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Type de canal",
          "ERROR": "Veuillez sélectionner votre type de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Jeton d'authentification",
          "PLACEHOLDER": "Veuillez entrer votre jeton d'authentification Twilio",
          "ERROR": "Ce champ est requis"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nom de la boîte de réception",
          "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
          "ERROR": "Ce champ est requis"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numéro de téléphone",
          "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel le message sera envoyé.",
          "ERROR": "Veuillez fournir un numéro de téléphone valide qui commence par un signe `+` et ne contient aucun espace."
        },
        "API_CALLBACK": {
          "TITLE": "URL de rappel (callback)",
          "SUBTITLE": "Vous devez configurer l'URL de rappel (callback) du message dans Twilio avec l'URL mentionnée ici."
        },
        "SUBMIT_BUTTON": "Créer le canal Twilio",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu authentifier les identifiants Twilio, veuillez réessayer"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Commencez à soutenir vos clients par SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bande passante",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID du compte client",
            "PLACEHOLDER": "Veuillez entrer votre ID de compte de bande passante",
            "ERROR": "Ce champ est requis"
          },
          "API_KEY": {
            "LABEL": "Clé de l'API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Ce champ est requis"
          },
          "API_SECRET": {
            "LABEL": "Secret API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Ce champ est requis"
          },
          "APPLICATION_ID": {
            "LABEL": "ID de l'application",
            "PLACEHOLDER": "Veuillez entrer votre ID d'application de bande passante",
            "ERROR": "Ce champ est requis"
          },
          "INBOX_NAME": {
            "LABEL": "Nom de la boîte de réception",
            "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
            "ERROR": "Ce champ est requis"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numéro de téléphone",
            "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel le message sera envoyé.",
            "ERROR": "Veuillez fournir un numéro de téléphone valide qui commence par un signe `+` et ne contient aucun espace."
          },
          "SUBMIT_BUTTON": "Créer un canal de bande passante",
          "API": {
            "ERROR_MESSAGE": "Nous n'avons pas pu authentifier les identifiants de bande passante, veuillez réessayer"
          },
          "API_CALLBACK": {
            "TITLE": "URL de rappel (callback)",
            "SUBTITLE": "Vous devez configurer l'URL de rappel du message en bande passante avec l'URL mentionnée ici."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nom de la boîte de réception",
            "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
            "ERROR": "Ce champ est requis"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numéro de téléphone",
            "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel les messages seront envoyés.",
            "ERROR": "Veuillez fournir un numéro de téléphone valide commençant par un signe « + »."
          },
          "SUBMIT_BUTTON": "Créer le canal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Nous n'avons pas pu créer le canal SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nom de la boîte de réception",
            "PLACEHOLDER": "Veuillez entrer un nom de boîte de réception",
            "ERROR": "Ce champ est requis"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numéro de téléphone",
            "PLACEHOLDER": "Veuillez entrer le numéro de téléphone à partir duquel les messages seront envoyés.",
            "ERROR": "Veuillez fournir un numéro de téléphone valide commençant par un signe « + »."
          },
          "SUBMIT_BUTTON": "Créer le canal DIDWW",
          "API": {
            "ERROR_MESSAGE": "Nous n'avons pas pu créer le canal DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "Cloud WhatsApp"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Vous devez configurer l'URL du webhook et le jeton de vérification du portail Facebook Developer avec les valeurs indiquées ci-dessous.",
          "WEBHOOK_URL": "URL du Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Jeton de vérification du Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configuration rapide avec Meta",
          "DESC": "Vous allez être redirigé vers Meta pour vous connecter à votre compte WhatsApp Business. Disposer d'un accès administrateur facilitera la configuration.",
          "BENEFITS": {
            "EASY_SETUP": "Aucune configuration manuelle requise",
            "SECURE_AUTH": "Authentification sécurisée basée sur OAuth",
            "AUTO_CONFIG": "Configuration automatique du webhook et du numéro de téléphone"
          },
          "SUBMIT_BUTTON": "Se connecter avec WhatsApp Business",
          "AUTH_PROCESSING": "Authentification avec Meta en cours",
          "WAITING_FOR_BUSINESS_INFO": "Veuillez terminer la configuration de l'entreprise dans la fenêtre Meta...",
          "PROCESSING": "Configuration de votre compte WhatsApp Business en cours",
          "CANCELLED": "L'inscription WhatsApp a été annulée",
          "WAITING_FOR_AUTH": "En attente de l'authentification...",
          "INVALID_BUSINESS_DATA": "Données d'entreprise invalides reçues de Facebook. Veuillez réessayer.",
          "SIGNUP_ERROR": "Une erreur d'inscription est survenue",
          "SDK_LOAD_ERROR": "Impossible de charger le SDK Facebook. Veuillez réessayer.",
          "AUTH_NOT_COMPLETED": "Authentification non terminée. Veuillez recommencer le processus.",
          "SUCCESS_FALLBACK": "Le compte WhatsApp Business a été configuré avec succès",
          "RECONNECTED": "Le canal WhatsApp a été reconnecté avec succès"
        },
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Intégrez le canal API et commencez à aider vos clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL du Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL du Webhook"
        },
        "SUBMIT_BUTTON": "Créer un canal API",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal API"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canal Salesforce",
        "DESC": "Intégrez-vous au canal Salesforce et commencez à prendre en charge vos clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Configurez l'URL de base pour votre instance Salesforce.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Ce champ est requis"
        },
        "KEY_ID": {
          "LABEL": "ID de clé",
          "SUBTITLE": "ID de clé pour votre canal Salesforce.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Ce champ est requis"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret pour votre canal Salesforce.",
          "PLACEHOLDER": "*****",
          "ERROR": "Ce champ est requis"
        },
        "SUBMIT_BUTTON": "Créer le canal Salesforce",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL du webhook",
          "SUBTITLE": "Vous devez configurer l'URL du webhook dans Salesforce avec l'URL mentionnée ici."
        },
        "BEARER_TOKEN": {
          "TITLE": "Jeton Bearer",
          "SUBTITLE": "Utilisez ce jeton Bearer pour l'authentification lors de la configuration du webhook dans Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Remplacer l'expéditeur de l'e-mail",
          "SUBTITLE": "Si défini, cette adresse e-mail sera utilisée comme expéditeur pour tous les e-mails sortants au lieu de l'e-mail source de la conversation.",
          "PLACEHOLDER": "ex. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canal Allegro",
        "DESC": "Connectez un compte vendeur Allegro et répondez à ses messages depuis le centre de contact.",
        "CHANNEL_NAME": {
          "LABEL": "Nom de la boîte de réception",
          "SUBTITLE": "Le nom que les agents voient pour cette boîte de réception.",
          "PLACEHOLDER": "Entrez un nom de boîte de réception",
          "ERROR": "Ce champ est requis"
        },
        "SUBMIT_BUTTON": "Se connecter avec Allegro",
        "API": {
          "ERROR_MESSAGE": "Une erreur est survenue lors de la connexion à Allegro, veuillez réessayer"
        },
        "SELLER_LOGIN": {
          "TITLE": "Identifiant Allegro",
          "SUBTITLE": "Le compte vendeur pour lequel cette boîte de réception lit et répond aux messages."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canal Kaufland",
        "DESC": "Répondez aux messages de tickets que les acheteurs vous envoient sur la marketplace Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "La Client Key (clé client) de 32 caractères, disponible sur la page des paramètres API de votre compte vendeur Kaufland.",
          "PLACEHOLDER": "Clé de 32 caractères",
          "ERROR": "Entrez la Client Key de 32 caractères"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "La Secret Key (clé secrète) de 64 caractères associée à la Client Key. Kaufland ne l'affiche qu'une seule fois et ne la renvoie jamais à cette page.",
          "PLACEHOLDER": "Clé de 64 caractères",
          "ERROR": "Entrez la Secret Key de 64 caractères"
        },
        "SUBMIT_BUTTON": "Créer un canal Kaufland",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Déconnecté",
          "MESSAGE": "Kaufland a rejeté ces clés API. Saisissez à nouveau la client key et la secret key pour reconnecter cette boîte de réception."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal Courriel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "EMAIL": {
          "LABEL": "Courriel",
          "SUBTITLE": "Adresse de courriel où vos clients vous envoient des demandes d'assistance",
          "PLACEHOLDER": "Courriel"
        },
        "SUBMIT_BUTTON": "Créer le canal Courriel",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal courriel"
        },
        "FINISH_MESSAGE": "Commencez à transférer vos courriels à l'adresse suivante."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Intégrez le canal LINE et commencez à assister vos clients.",
        "CHANNEL_NAME": {
          "LABEL": "Nom du canal",
          "PLACEHOLDER": "Veuillez entrer un nom de canal",
          "ERROR": "Ce champ est requis"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID du canal LINE",
          "PLACEHOLDER": "ID du canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret du canal LINE",
          "PLACEHOLDER": "Secret du canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Jeton de canal LINE",
          "PLACEHOLDER": "Jeton de canal LINE"
        },
        "SUBMIT_BUTTON": "Créer le canal LINE",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL de rappel (callback)",
          "SUBTITLE": "Vous devez configurer l'URL du webhook dans l'application LINE avec l'URL mentionnée ici."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal Telegram",
        "DESC": "Intégrez le canal Telegram et commencez à assister vos clients.",
        "BOT_TOKEN": {
          "LABEL": "Jeton du robot",
          "SUBTITLE": "Configurez le jeton de bot que vous avez obtenu de Telegram BotFather.",
          "PLACEHOLDER": "Jeton du robot"
        },
        "SUBMIT_BUTTON": "Créer un canal Telegram",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu enregistrer le canal Telegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Appels téléphoniques",
        "DESC": "Configurez les appels téléphoniques qui apparaîtront sous cette boîte de réception.",
        "NAME": {
          "LABEL": "Nom de la boîte de réception",
          "SUBTITLE": "Choisissez un nom facilement identifiable."
        },
        "PHONE_NUMBER": {
          "LABEL": "Numéro de téléphone",
          "SUBTITLE": "Entrez les numéros de téléphone qui appartiennent à cette boîte de réception, vous pourrez ajouter d'autres numéros plus tard.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Créer la boîte de réception Appels téléphoniques",
        "API": {
          "ERROR_MESSAGE": "Nous n'avons pas pu créer la boîte de réception"
        }
      },
      "AUTH": {
        "TITLE": "Choisir un canal",
        "DESC": "Le chat prend en charge les widgets de chat en direct, Facebook Messenger, WhatsApp, les e-mails, etc. comme canaux. Si vous souhaitez créer un canal personnalisé, vous pouvez le créer à l'aide du canal API. Pour commencer, choisissez l'un des canaux ci-dessous."
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Ici vous pouvez ajouter des agents pour gérer votre boîte de réception nouvellement créée. Seuls ces agents sélectionnés auront accès à votre boîte de réception. Les agents qui ne font pas partie de cette boîte de réception ne seront pas en mesure de voir ou de répondre aux messages de cette boîte de réception lorsqu'ils se connectent. <br> <b>PS :</b> En tant qu'administrateur, si vous avez besoin d'accéder à toutes les boîtes de réception, vous devriez vous ajouter en tant qu'agent à toutes les boîtes de réception que vous créez.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Sélectionner les agents de la boîte de réception"
      },
      "DETAILS": {
        "TITLE": "Détails de la boîte de réception",
        "DESC": "Dans le menu déroulant ci-dessous, sélectionnez la page Facebook que vous voulez connecter au chat. Vous pouvez également donner un nom personnalisé à votre boîte de réception pour une meilleure identification."
      },
      "FINISH": {
        "TITLE": "Mission accomplie !",
        "DESC": "Vous avez terminé avec succès l’intégration de votre page Facebook avec le chat. La prochaine fois qu’un client enverra un message à votre page, la conversation apparaîtra automatiquement dans votre boîte de réception.<br>Nous fournissons également un script de widget que vous pouvez facilement ajouter à votre site Web. Une fois que cela est configuré sur votre site web, les clients peuvent vous envoyer des messages directement depuis votre site Web sans l'aide d'un outil externe et la conversation apparaîtra ici, dans le chat.<br>Cool, hein ? Eh bien, nous essayons de l'être :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Sélectionnez votre fournisseur de messagerie",
        "DESCRIPTION": "Sélectionnez un fournisseur de messagerie dans la liste ci-dessous. Si vous ne voyez pas votre fournisseur de messagerie dans la liste, vous pouvez sélectionner l'autre fournisseur et fournir les identifiants IMAP et SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Cliquez sur le bouton Connexion avec Microsoft pour commencer. Vous allez rediriger vers la page de connexion par courriel. Une fois que vous avez accepté les autorisations demandées, vous serez redirigé vers l'étape de création de la boîte de réception.",
        "EMAIL_PLACEHOLDER": "Entrez votre adresse e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Une erreur s'est produite lors de la connexion à Microsoft, veuillez réessayer"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Entrez votre adresse e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authentification avec Facebook ...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Une erreur s'est produite, veuillez rafraîchir la page ...",
      "ERROR_FB_UNAUTHORIZED": "Vous n'êtes pas autorisé à effectuer cette action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Veuillez vous assurer que vous avez un contrôle total sur la page Facebook. Vous pouvez en savoir plus sur les rôles Facebook <a href=\" https://www.facebook.com/help/187316341316631\">ici</a>.",
      "ERROR_CHANNEL_CREATION": "Nous n'avons pas pu créer la boîte de réception. Veuillez réessayer.",
      "CREATING_CHANNEL": "Création de votre boîte de réception ...",
      "TITLE": "Configurer les détails de la boîte de réception",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Ajouter des agents",
      "ADD_AGENTS": "Ajout d'agents à votre boîte de réception ..."
    },
    "FINISH": {
      "TITLE": "Votre boîte de réception est prête !",
      "MESSAGE": "Vous pouvez maintenant vous impliquer auprès de vos clients par le biais de votre nouveau canal. Bonne assistance",
      "BUTTON_TEXT": "Emmenez-moi là",
      "MORE_SETTINGS": "Plus de paramètres",
      "WEBSITE_SUCCESS": "Vous avez terminé avec succès la création d'un canal Web. Copiez le code affiché ci-dessous et collez-le sur votre site web. La prochaine fois qu'un client utilisera le chat en direct, la conversation apparaîtra automatiquement dans votre boîte de réception."
    },
    "REAUTH": "Réautoriser",
    "VIEW": "Voir",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Paramètres de boîte de réception mis à jour avec succès",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Affectation automatique mise à jour avec succès",
        "ERROR_MESSAGE": "Nous n'avons pas pu mettre à jour les paramètres de la boîte de réception. Veuillez réessayer plus tard."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nom de l'expéditeur",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "Par exemple:",
        "FRIENDLY": {
          "TITLE": "Amical",
          "FROM": "de",
          "SUBTITLE": "Ajoute le nom de l'agent qui a envoyé la réponse dans le nom de l'expéditeur pour la rendre plus conviviale."
        },
        "PROFESSIONAL": {
          "TITLE": "Professionnel",
          "SUBTITLE": "Utilisez uniquement le nom d'entreprise configuré comme nom d'expéditeur dans l'en-tête du courriel."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configurez votre nom d'entreprise",
          "PLACEHOLDER": "Entrez le nom de votre entreprise",
          "SAVE_BUTTON_TEXT": "Enregistrer"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Aucun"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_HMAC": {
        "LABEL": "Activer"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Activé",
        "DISABLED": "Désactivé"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Activer la synchronisation des e-mails entrants"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Activer le domaine e-mail personnalisé (service payant)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Activer le traitement des commentaires Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Signature HTML",
        "SUB_TEXT": "Cette signature sera ajoutée au pied de page de chaque message envoyé depuis cette boîte de réception.",
        "HTML_CONTENT": "Code HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} sera remplacé par le nom de l'agent.\n{'{{'}email{'}}'} sera remplacé par l'adresse e-mail de l'agent qui a envoyé l'e-mail.\n{'{{'}position{'}}'} sera remplacé par le poste de l'agent.\n{'{{'}custom_line{'}}'} sera remplacé par la ligne personnalisée de l'agent.\n{'{{'}email_signature_picture{'}}'} sera remplacé par l'URL de l'image de signature e-mail de l'agent (pas une balise d'image) — utilisez-la comme source d'image (l'attribut src d'une balise img).",
        "PREVIEW": "Aperçu"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signatures par pays",
        "SUB_TEXT": "Une réponse reçoit la signature du pays de l'acheteur.",
        "HELP": "Une réponse est signée selon le pays de sa conversation : la boutique Kaufland, la place de marché de la commande Allegro ou, à défaut, la langue dans laquelle écrit l'acheteur. Lorsque le pays est inconnu ou n'a pas de signature ici, la signature HTML ci-dessus est utilisée. Les places de marché interdisent les liens vers votre site web et les coordonnées ; limitez-vous donc à une formule de salutation et à {'{{'}name{'}}'}.",
        "EMPTY": "Vous n'avez pas encore de signature par pays ; les réponses utilisent donc la signature HTML ci-dessus.",
        "COUNTRY": "Sélectionner un pays",
        "ADD": "Ajouter une signature par pays",
        "REMOVE": "Supprimer"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Préfixe de numérotation du numéro de téléphone",
        "PLACEHOLDER": "Entrez le préfixe pour un routage correct des appels (ex. *99)",
        "HELP_TEXT": "Ce préfixe sera automatiquement ajouté aux numéros de téléphone des contacts lors de la numérotation depuis cette boîte de réception."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Texte du bouton « résoudre plus tard »",
        "PLACEHOLDER": "p. ex. Nous résoudrons ce sujet par e-mail. Maintenant, je voudrais poser une autre question.",
        "HELP_TEXT": "Libellé du bouton du widget qui permet au visiteur de quitter le sujet en cours et de poser une autre question. Laissez ce champ vide pour utiliser le texte par défaut dans la langue du visiteur."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Reporter automatiquement les appels manqués pendant X minutes",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Reporte automatiquement les appels manqués pendant le nombre de minutes spécifié. Laissez vide ou 0 pour désactiver."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Résoudre un appel manqué après X rappels infructueux",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Lorsqu'un appel manqué a été rappelé X fois sans que le client ne réponde, il est résolu automatiquement et une note privée est ajoutée. Laissez vide ou 0 pour désactiver."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Suggestions de questions",
        "SUB_TEXT": "Configurez des questions prédéfinies que les clients peuvent utiliser pour interagir avec vos agents.",
        "QUESTIONS_LABEL": "Questions",
        "ADD_QUESTION": "Ajouter une question",
        "QUESTION": "Question",
        "REMOVE": "Supprimer",
        "QUESTION_TEXT": "Texte affiché dans la bulle.",
        "QUESTION_TEXT_PLACEHOLDER": "Requis",
        "QUESTION_PAYLOAD": "Texte envoyé lorsqu'on clique.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Facultatif",
        "SAVE": "Enregistrer",
        "NO_BOT_MESSAGE": "Pour générer des suggestions IA supplémentaires, veuillez connecter un bot.",
        "BOT_CONNECTED_MESSAGE": "Les suggestions de questions IA du bot peuvent être activées dans ses",
        "BOT_SETTINGS_LINK": "paramètres"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Adresses e-mail alternatives",
        "SUB_TEXT": "Adresses supplémentaires que cette boîte de réception doit considérer comme les siennes lors de la réception d'e-mails transférés.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Ajouter",
        "REMOVE": "Supprimer",
        "EMPTY": "Aucune adresse e-mail alternative configurée.",
        "HELP_TEXT": "Lorsqu'un e-mail arrive avec l'une de ces adresses comme destinataire, les réponses seront envoyées avec la même adresse comme expéditeur. Assurez-vous que votre serveur SMTP sortant autorise l'envoi depuis ces adresses.",
        "SIGNATURE_LABEL": "Signature",
        "PRIMARY_SIGNATURE": "Principale (par défaut)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Signatures supplémentaires",
        "SUB_TEXT": "Définissez ici des signatures supplémentaires, puis attribuez-les aux e-mails alternatifs ci-dessous.",
        "OPTION": "Signature {number}",
        "ADD": "Ajouter une signature",
        "REMOVE": "Supprimer",
        "HELP_TEXT": "Lorsqu'une réponse est envoyée depuis un e-mail alternatif, la signature qui lui est attribuée est utilisée à la place de la signature de la boîte de réception. Les e-mails alternatifs laissés sur « Principale (par défaut) » utilisent la signature de la boîte de réception."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Supprimer",
      "AVATAR_DELETE_BUTTON_TEXT": "Supprimer l'avatar",
      "DELETE_REQUESTED_TOOLTIP": "Cette boîte de réception est marquée pour suppression",
      "RESTORE_BUTTON_TEXT": "Restaurer",
      "CONFIRM": {
        "TITLE": "Confirmer la suppression",
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer ",
        "PLACE_HOLDER": "Veuillez taper {inboxName} pour confirmer",
        "YES": "Oui, supprimer ",
        "NO": "Non, Conserver "
      },
      "API": {
        "SUCCESS_MESSAGE": "Boîte de réception supprimée avec succès",
        "MARKED_FOR_DELETION_MESSAGE": "Boîte de réception marquée pour suppression",
        "RESTORE_SUCCESS_MESSAGE": "Boîte de réception restaurée avec succès",
        "ERROR_MESSAGE": "Impossible de supprimer la boîte de réception. Veuillez réessayer plus tard.",
        "RESTORE_ERROR_MESSAGE": "Impossible de restaurer la boîte de réception. Veuillez réessayer plus tard.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar de la boîte de réception supprimé avec succès",
        "AVATAR_ERROR_MESSAGE": "Impossible de supprimer l'avatar de la boîte de réception. Veuillez réessayer plus tard."
      }
    },
    "TABS": {
      "SETTINGS": "Paramètres",
      "COLLABORATORS": "Collaborateurs",
      "AUTOMATIC_PRIORITY": "Priorité automatique",
      "AUTOMATIC_LABELING": "Étiquetage automatique",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campagnes",
      "PRE_CHAT_FORM": "Formulaire avant chat",
      "BUSINESS_HOURS": "Heures de bureau",
      "WIDGET_BUILDER": "Constructeur de Widget",
      "BOT_CONFIGURATION": "Configuration du bot",
      "SLA": "SLA"
    },
    "SETTINGS": "Paramètres",
    "FEATURES": {
      "LABEL": "Fonctionnalités",
      "DISPLAY_FILE_PICKER": "Afficher le sélecteur de fichiers sur le widget",
      "DISPLAY_EMOJI_PICKER": "Afficher le sélecteur d'émoticônes sur le widget",
      "ALLOW_END_CONVERSATION": "Permettre aux utilisateurs de terminer la conversation depuis le widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Afficher le bouton « Démarrer une nouvelle conversation » dans l'en-tête du widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Masquer le champ de saisie lorsque le bouton démarrer une nouvelle conversation est affiché",
      "SHOW_HANDOFF_BUTTON": "Afficher le bouton « Transférer à un opérateur » dans l'en-tête du widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Utiliser le nom de la boîte de réception et l'avatar pour le bot",
      "ALLOW_OFFLINE_REPLY": "Autoriser les agents à envoyer des messages lorsque le contact est hors ligne et que la continuité par e-mail n'est pas disponible",
      "AUTO_CLOSE_OLD": "Marquer tous les appels précédents du même numéro comme résolus lorsqu'un appel est résolu",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Attribuer automatiquement les appels manqués lors d'un appel sortant"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script du Widget Web",
      "MESSENGER_SUB_HEAD": "Placez ce code avant la fermeture de votre balise body",
      "INBOX_AGENTS": "Agents",
      "INBOX_TEAMS": "Équipes",
      "INBOX_COOPERATORS": "Collaborateurs",
      "SELECT_PLACEHOLDER": "Sélectionner",
      "AGENTS_OR_TEAMS_INFO": "Vous pouvez assigner soit des agents, soit des équipes - pas les deux simultanément.",
      "AGENT_ASSIGNMENT": "Konversationsauftrag",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualisieren Sie die Konversationszuweisungseinstellungen",
      "UPDATE": "Mettre à jour",
      "ENABLE_EMAIL_COLLECT_BOX": "Activer la boîte de collecte des courriels",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Activer ou désactiver la boîte de collecte des courriels pour les nouvelles conversations",
      "AUTO_ASSIGNMENT": "Activer l'assignation automatique",
      "ENABLE_CSAT": "Activer CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Activer le CSAT sur chaque message",
      "SENDER_NAME_SECTION": "Activer le nom de l'agent dans l'e-mail",
      "ENABLE_CSAT_SUB_TEXT": "Activer/Désactiver l'enquête CSAT(satisfaction du client) après avoir résolu une conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Activer/Désactiver l'option d'enquête CSAT pour chaque message envoyé par les agents",
      "SENDER_NAME_SECTION_TEXT": "Activer/Désactiver l'affichage du nom de l'agent dans l'e-mail, si désactivé, il affichera le nom de l'entreprise",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Activer la continuité de la conversation par e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Les conversations se poursuivront par courrier électronique si l'adresse e-mail du contact est disponible.",
      "RESPOND_FROM_EMAIL": "Répondre depuis un e-mail",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Les e-mails envoyés au client — réponses et transcriptions de conversation — sont envoyés avec les paramètres SMTP de la boîte de réception e-mail sélectionnée, depuis l'adresse sélectionnée (l'adresse propre de la boîte de réception ou l'un de ses alias), et les réponses du client reviennent par son adresse IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Les transcriptions de conversation sont envoyées avec les paramètres SMTP de la boîte de réception e-mail sélectionnée, depuis l'adresse sélectionnée (l'adresse propre de la boîte de réception ou l'un de ses alias), et les réponses reviennent par son adresse IMAP.",
      "SHOW_WELCOME_SCREEN": "Afficher l'écran de bienvenue",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Afficher l'écran de bienvenue lorsque le widget est ouvert. Si désactivé, le widget passera directement à la vue de la conversation.",
      "AUTO_CLOSE_PENDING": "Résoudre automatiquement les chats IA après (heures)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Résout automatiquement les chats IA après X heures d'inactivité.",
      "LOCK_TO_SINGLE_CONVERSATION": "Verrouiller à une seule conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Activer ou désactiver plusieurs conversations pour le même contact dans cette boîte de réception",
      "INBOX_UPDATE_TITLE": "Paramètres de boîtes de réception",
      "INBOX_UPDATE_SUB_TEXT": "Mettre à jour les paramètres de votre boîte de réception",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activer ou désactiver l'affectation automatique de nouvelles conversations aux agents ajoutés à cette boîte de réception.",
      "HMAC_VERIFICATION": "Validation de l'identité de l'utilisateur",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Faire pivoter la clé",
        "TITLE": "Faire pivoter la clé secrète ?",
        "WARNING": "La clé actuelle est révoquée dès que vous la faites pivoter.",
        "WARNING_DETAIL": "Il n'y a pas de période de chevauchement et elle ne peut pas être restaurée.",
        "IMPACT": "Vos serveurs doivent signer les utilisateurs avec la nouvelle clé. Toute personne encore signée avec l'ancienne échoue à la vérification. Si la validation de l'identité est requise, elle ne peut pas démarrer de conversation.",
        "CONFIRM": "Faire pivoter la clé",
        "CANCEL": "Annuler",
        "SUCCESS": "Clé secrète pivotée avec succès",
        "ERROR": "Nous n'avons pas pu faire pivoter la clé secrète, veuillez réessayer"
      },
      "HMAC_LINK_TO_DOCS": "Vous pouvez en lire plus ici.",
      "HMAC_MANDATORY_VERIFICATION": "Forcer la validation de l'identité de l'utilisateur",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Forcer une nouvelle conversation à chaque chargement du widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Si activé, ouvrir le widget dans un nouvel onglet ou une nouvelle fenêtre démarre une nouvelle conversation.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Oublier le contact lorsqu'une nouvelle conversation est démarrée",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Si désactivé, une nouvelle conversation démarrée depuis le widget conserve le contact précédent.",
      "INBOX_IDENTIFIER": "Identificateur de la boîte de réception",
      "INBOX_IDENTIFIER_SUB_TEXT": "Utilisez le jeton `inbox_identifier` affiché ici pour authentifier vos clients API.",
      "FORWARD_EMAIL_TITLE": "Transférer par e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Commencez à transférer vos courriels à l'adresse suivante.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Synchronisation des e-mails",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Activer la synchronisation automatique et le téléchargement des e-mails entrants depuis cette boîte de réception",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domaine e-mail personnalisé",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Activer pour utiliser un domaine e-mail personnalisé pour les e-mails sortants",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Vous pouvez en lire davantage ici.",
      "FACEBOOK_COMMENTS_TITLE": "Commentaires Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Autoriser les messages après résolution de la conversation",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Autoriser les utilisateurs à envoyer des messages même après la résolution de la conversation.",
      "WIDGET_STATUS_LABEL": "Statut du widget",
      "WIDGET_STATUS_ENABLED": "Activé",
      "WIDGET_STATUS_BUSINESS_HOURS": "Activé pendant les heures d'ouverture",
      "WIDGET_STATUS_DISABLED": "Désactivé",
      "WIDGET_STATUS_HELP_TEXT": "Contrôle quand le widget est affiché aux visiteurs sur votre site Web",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Mettre à jour les paramètres du formulaire de pré-chat",
      "EXPLICIT_CSAT_LOCALE": "Langue de l'enquête CSAT et des e-mails",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Choisissez la langue de tous les e-mails clients, y compris les enquêtes CSAT, les transcriptions de conversations et les notifications par e-mail",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Hériter du compte",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Connexion WhatsApp",
        "SUBTITLE": "Comment cette boîte de réception est connectée à WhatsApp.",
        "PROVIDER": "Fournisseur",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Connecté via l’inscription intégrée de Meta",
        "STATUS": "Statut",
        "CONNECTED": "Connecté",
        "RECONNECT_HINT": "Cliquez sur Reconnecter dans le bandeau ci-dessus.",
        "PHONE_NUMBER": "Numéro de téléphone",
        "BUSINESS_ACCOUNT": "ID du compte WhatsApp Business",
        "OPEN_MANAGER": "Ouvrir dans WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID du numéro de téléphone",
        "TEMPLATES": "Modèles de messages",
        "TEMPLATES_COUNT": "{approved} sur {total} approuvés",
        "TEMPLATES_SYNCED": "Dernière synchronisation : {date}",
        "TEMPLATES_NOT_SYNCED": "Pas encore synchronisés",
        "MANAGE_TEMPLATES": "Gérer les modèles"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centre d'aide",
      "PLACEHOLDER": "Sélectionnez le centre d'aide",
      "SELECT_PLACEHOLDER": "Sélectionnez le centre d'aide",
      "REMOVE": "Supprimer le centre d'aide",
      "SUB_TEXT": "Attachez un centre d'aide avec la boîte de réception"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limite de l'affectation automatique",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Veuillez entrer une valeur supérieure à 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limiter le nombre maximum de conversations de cette boîte de réception qui peuvent être assignées automatiquement à un agent"
    },
    "SLA": {
      "TITLE": "Politiques SLA",
      "SUB_TEXT": "Configurez les temps de réponse et de résolution SLA pour chaque niveau de priorité de conversation.",
      "LOADING": "Chargement des politiques SLA...",
      "FIELDS": {
        "ACTIVE": "Actif",
        "TICKET_PRIORITY": "Priorité du ticket",
        "FIRST_RESPONSE_TIME": "Temps de première réponse",
        "EVERY_RESPONSE_TIME": "Temps de chaque réponse",
        "RESOLUTION_TIME": "Temps de résolution",
        "PLACEHOLDER": "ex. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Politiques SLA mises à jour avec succès.",
        "ERROR_MESSAGE": "Impossible de mettre à jour les politiques SLA. Veuillez réessayer."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Priorité automatique",
      "SUB_TEXT": "Configurez l'attribution automatique de priorité en fonction du contenu de la conversation.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avis de facturation",
        "MESSAGE": "Chaque évaluation de priorité entraînera des frais. Veuillez consulter les détails de votre plan pour connaître les tarifs."
      },
      "MODE": {
        "OFF": "Désactivé",
        "ALL_MESSAGES": "Activé pour tous les messages entrants",
        "FIRST_MESSAGE": "Activé pour le premier message entrant uniquement"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configuration des niveaux de priorité",
        "SUB_TEXT": "Configurez les niveaux de priorité qui doivent être activés et leurs descriptions. Fournissez des critères clairs pour que l'IA détermine quand cette priorité doit être attribuée."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Décrivez les conversations à marquer comme priorité {priority}",
      "SET_AS_DEFAULT": "Définir comme priorité par défaut",
      "MULTIPLE_DEFAULTS_WARNING": "Un seul niveau de priorité doit être défini comme défaut. Veuillez décocher les autres."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Étiquetage automatique",
      "SUB_TEXT": "Configurez l'attribution automatique d'étiquettes en fonction du contenu de la conversation.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Avis de facturation",
        "MESSAGE": "Chaque évaluation d'étiquetage entraînera des frais. Veuillez consulter les détails de votre plan pour connaître les tarifs."
      },
      "MODE": {
        "OFF": "Désactivé",
        "CONVERSATION_OPEN": "À l'ouverture de la conversation",
        "CONVERSATION_CLOSE": "À la fermeture de la conversation",
        "ALL_MESSAGES": "À chaque message - quel que soit l'état",
        "FIRST_MESSAGE": "Au premier message - quel que soit l'état"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configuration des étiquettes",
        "SUB_TEXT": "Configurez les étiquettes disponibles pour l'attribution automatique et leurs descriptions. Fournissez des critères clairs pour que l'IA détermine quand cette étiquette doit être appliquée."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Décrivez les conversations à étiqueter comme {label}. Si vous laissez vide, la description de l'étiquette sera utilisée.",
      "NO_LABELS_MESSAGE": "Aucune étiquette trouvée. Créez d'abord des étiquettes pour activer l'étiquetage automatique.",
      "CREATE_LABELS_LINK": "Créer des étiquettes"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Réautoriser",
      "SUBTITLE": "Votre connexion Facebook a expiré, veuillez reconnecter votre page Facebook pour continuer les services",
      "MESSAGE_SUCCESS": "Reconnexion réussie",
      "MESSAGE_ERROR": "Une erreur est survenue, veuillez réessayer"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Les formulaires précédant le chat vous permettent de saisir les informations de l'utilisateur avant qu'ils ne commencent à discuter avec vous.",
      "SET_FIELDS": "Champs du formulaire de pré-chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Champs",
        "LABEL": "Étiquettes",
        "PLACE_HOLDER": "Espace réservé",
        "KEY": "Clé",
        "TYPE": "Type",
        "REQUIRED": "Obligatoire"
      },
      "ENABLE": {
        "LABEL": "Activer le formulaire précédant le chat",
        "OPTIONS": {
          "ENABLED": "Oui",
          "DISABLED": "Non"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Message avant la discussion",
        "PLACEHOLDER": "Ce message serait visible pour les utilisateurs avec le formulaire"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Les visiteurs doivent indiquer leur nom et leur courriel avant de commencer le chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Définissez votre disponibilité",
      "SUBTITLE": "Définissez votre disponibilité sur votre widget livechat",
      "WEEKLY_TITLE": "Définissez vos horaires de travail",
      "TIMEZONE_LABEL": "Sélectionnez le fuseau horaire",
      "UPDATE": "Mettre à jour les paramètres des heures de bureau",
      "TOGGLE_AVAILABILITY": "Activer la disponibilité aux heures de bureau pour cette boîte de réception",
      "UNAVAILABLE_MESSAGE_LABEL": "Message d'indisponibilité pour les visiteurs",
      "TOGGLE_HELP": "Activer la disponibilité professionnelle montrera les heures disponibles sur le widget chat en direct même si tous les agents sont hors ligne. En dehors des heures disponibles, les visiteurs peuvent être avertis avec un message et un formulaire de préconversation.",
      "DAY": {
        "ENABLE": "Activer la disponibilité pour ce jour",
        "UNAVAILABLE": "Non disponible",
        "HOURS": "heures",
        "VALIDATION_ERROR": "L'heure de début doit être avant l'heure de fermeture.",
        "CHOOSE": "Sélectionner"
      },
      "ALL_DAY": "Toute la journée",
      "SAVE_TO_ALL": "Enregistrer dans toutes les boîtes de réception",
      "SAVE_TO_ALL_TITLE": "Copier les heures d'ouverture",
      "SAVE_TO_ALL_CONFIRM": "Les paramètres de ce formulaire (bascule de disponibilité, message d'absence, fuseau horaire et heures d'ouverture) seront copiés vers toutes les autres boîtes de réception sauf les boîtes e-mail et téléphone. Êtes-vous sûr de vouloir continuer ?",
      "SAVE_TO_ALL_CANCEL": "Annuler",
      "SAVE_TO_ALL_YES": "Oui, copier à tous",
      "SAVE_TO_ALL_SUCCESS": "Heures d'ouverture copiées avec succès vers toutes les autres boîtes de réception",
      "SAVE_TO_ALL_ERROR": "Échec de la copie des heures d'ouverture vers les autres boîtes de réception"
    },
    "PHONE": {
      "TITLE": "Paramètres téléphone",
      "SUBTITLE": "Configurez les appels qui apparaîtront sous cette boîte de réception.",
      "UPDATE": "Enregistrer les paramètres",
      "EDIT": {
        "SUCCESS_MESSAGE": "Paramètres téléphone mis à jour",
        "ERROR_MESSAGE": "Échec de la mise à jour des paramètres téléphone"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Numéros de téléphone",
        "SUBTITLE": "Entrez les numéros de téléphone qui appartiennent à cette boîte de réception.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Ajouter un numéro de téléphone"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Définir vos détails IMAP",
      "NOTE_TEXT": "Pour activer le SMTP, veuillez configurer IMAP.",
      "UPDATE": "Modifier les paramètres IMAP",
      "TOGGLE_AVAILABILITY": "Activer la configuration IMAP pour cette boîte de réception",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Paramètres IMAP mis à jour avec succès",
        "ERROR_MESSAGE": "Impossible de mettre à jour les paramètres IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresse IP",
        "PLACE_HOLDER": "Adresse (ex: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Se connecter",
        "PLACE_HOLDER": "Se connecter"
      },
      "PASSWORD": {
        "LABEL": "Mot de passe",
        "PLACE_HOLDER": "Mot de passe"
      },
      "ENABLE_SSL": "Activer SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Réautoriser votre compte MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Définissez vos détails SMTP",
      "UPDATE": "Mettre à jour les paramètres",
      "TOGGLE_AVAILABILITY": "Activer la configuration SMTP pour cette boîte de réception",
      "TOGGLE_HELP": "Activer SMTP aidera l'utilisateur à envoyer des e-mails",
      "EDIT": {
        "SUCCESS_MESSAGE": "Paramètres IMAP mis à jour avec succès",
        "ERROR_MESSAGE": "Impossible de mettre à jour les paramètres IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresse IP",
        "PLACE_HOLDER": "Adresse (ex: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Se connecter",
        "PLACE_HOLDER": "Se connecter"
      },
      "PASSWORD": {
        "LABEL": "Mot de passe",
        "PLACE_HOLDER": "Mot de passe"
      },
      "DOMAIN": {
        "LABEL": "Domaine",
        "PLACE_HOLDER": "Domaine"
      },
      "ENCRYPTION": "Chiffrement",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Ouvrir le mode de vérification SSL",
      "AUTH_MECHANISM": "Identification"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Délivrabilité des e-mails (DNS)",
      "SUB_TITLE": "Nous vérifions les enregistrements SPF, DKIM, DMARC et MX de {domain} chaque jour ouvré. Lorsqu'un problème amène les serveurs de réception à refuser vos réponses ou à les classer en indésirables, les administrateurs reçoivent un e-mail avec la correction à apporter.",
      "RUN": "Lancer la vérification",
      "RUN_SUCCESS": "Vérification DNS terminée",
      "RUN_ERROR": "Impossible de lancer la vérification DNS, veuillez réessayer",
      "NOT_CHECKED": "Pas encore vérifié.",
      "CHECKED_AT": "Dernière vérification : {time}.",
      "DNS_UNAVAILABLE": "Lors de la dernière vérification, les serveurs de noms du domaine n'ont pas répondu. Le résultat ci-dessous provient de la vérification précédente.",
      "SENDER": {
        "SMTP": "Les réponses sont envoyées via {host}.",
        "PLATFORM": "Les réponses sont envoyées via nos serveurs de messagerie."
      },
      "STATUS": {
        "OK": "Tous les enregistrements sont en ordre",
        "WARNING": "Certains enregistrements pourraient être améliorés",
        "ERROR": "Les réponses risquent de ne pas arriver à destination",
        "UNKNOWN": "Inconnu"
      },
      "SEVERITY": {
        "ERROR": "Problème",
        "WARNING": "Avertissement"
      },
      "FIX": "Corrigez-le avec cet enregistrement DNS :",
      "RECORD_TYPE": "Type",
      "RECORD_HOST": "Nom",
      "RECORD_VALUE": "Valeur",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "L'enregistrement SPF est manquant",
          "DESCRIPTION": "Le domaine n'indique pas quels serveurs peuvent envoyer ses e-mails. De nombreux serveurs de messagerie considèrent alors vos réponses comme du spam. Ajoutez un enregistrement SPF qui autorise {sender}."
        },
        "spf_multiple": {
          "TITLE": "Le domaine a {count} enregistrements SPF",
          "DESCRIPTION": "Un domaine ne peut avoir qu'un seul enregistrement SPF. Avec plusieurs, les serveurs de réception ignorent le SPF et refusent souvent les e-mails. Fusionnez-les en un seul enregistrement."
        },
        "spf_not_authorized": {
          "TITLE": "Le SPF n'autorise pas le serveur qui envoie vos réponses",
          "DESCRIPTION": "Vos réponses sont envoyées via {sender}, mais l'enregistrement SPF du domaine ne l'indique pas. Enregistrement actuel : {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "L'enregistrement SPF nécessite trop de requêtes DNS",
          "DESCRIPTION": "Les serveurs de réception arrêtent de vérifier le SPF après {limit} requêtes DNS, mais {sender}, qui envoie vos réponses, n'est atteint qu'après {lookups}. Vos réponses échouent au contrôle SPF. Placez {sender} au début de l'enregistrement et supprimez les include que le domaine n'utilise plus."
        },
        "spf_lookups_others": {
          "TITLE": "Certains expéditeurs de l'enregistrement SPF dépassent la limite de requêtes",
          "DESCRIPTION": "L'enregistrement SPF nécessite {lookups} requêtes DNS, alors que les serveurs de réception s'arrêtent à {limit}. Vos réponses sont reconnues à temps et passent le contrôle, mais les e-mails de ces expéditeurs échouent au SPF : {senders}. Supprimez les include que le domaine n'utilise plus."
        },
        "spf_malformed": {
          "TITLE": "L'enregistrement SPF est défectueux",
          "DESCRIPTION": "Les serveurs de réception ne peuvent pas lire l'enregistrement SPF du domaine, qui ne protège donc pas vos réponses. Le problème se situe dans : {terms}. Remplacez l'enregistrement par la version corrigée."
        },
        "dkim_missing": {
          "TITLE": "La signature DKIM n'est pas configurée",
          "DESCRIPTION": "Nous n'avons trouvé aucune clé DKIM à l'adresse {selectors}. Sans elle, vos réponses ne sont pas signées et risquent davantage d'arriver dans les spams. Activez la signature DKIM pour le domaine auprès de votre fournisseur de messagerie."
        },
        "dmarc_missing": {
          "TITLE": "L'enregistrement DMARC est manquant",
          "DESCRIPTION": "Les grands fournisseurs de messagerie, comme Gmail et Microsoft, attendent un enregistrement DMARC. Sans lui, vos réponses risquent davantage d'arriver dans les spams."
        },
        "dmarc_fails": {
          "TITLE": "Le DMARC demande aux destinataires de rejeter vos réponses",
          "DESCRIPTION": "La politique DMARC du domaine est « {policy} » et vos réponses ne passent ni le SPF ni le DKIM : les serveurs de réception les refusent ou les classent dans les spams. Corrigez d'abord le SPF et le DKIM ci-dessus."
        },
        "dmarc_blocks_platform": {
          "TITLE": "Le DMARC bloque les réponses envoyées via nos serveurs de messagerie",
          "DESCRIPTION": "Cette boîte de réception envoie ses réponses via nos serveurs de messagerie, mais la politique DMARC du domaine est « {policy} » : les serveurs de réception les refusent ou les classent dans les spams. Configurez le SMTP de votre propre serveur de messagerie pour cette boîte."
        },
        "mx_missing": {
          "TITLE": "Le domaine n'a aucun enregistrement MX",
          "DESCRIPTION": "Sans enregistrement MX, personne ne peut envoyer d'e-mail au domaine : vos clients ne peuvent donc pas répondre à vos messages."
        }
      }
    },
    "NOTE": "Note : ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar du site web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar supprimé avec succès",
              "ERROR_MESSAGE": "Une erreur est survenue, veuillez réessayer"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nom du site web",
          "PLACE_HOLDER": "Entrez le nom de votre boîte de réception (ex: Acme Inc)",
          "ERROR": "Veuillez entrer un nom de site Web valide"
        },
        "WELCOME_HEADING": {
          "LABEL": "Titre de Bienvenue",
          "PLACE_HOLDER": "Salut!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Slogan d'accueil",
          "PLACE_HOLDER": "C'est simple de rentrer en contact avec nous. Demandez-nous quoi que ce soit ou partagez vos commentaires."
        },
        "REPLY_TIME": {
          "LABEL": "Temps de réponse",
          "IN_A_FEW_MINUTES": "En quelques minutes",
          "IN_A_FEW_HOURS": "En quelques heures",
          "IN_A_DAY": "En une journée"
        },
        "WIDGET_COLOR_LABEL": "Couleur du Widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position de la bulle du widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Hauteur maximale des messages non lus (px)",
          "PLACE_HOLDER": "Aucune limite",
          "HELP_TEXT": "Limitez la hauteur maximale de la fenêtre des messages non lus en pixels. Laissez vide pour le comportement par défaut (aucune limite)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Type de bulle de widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Discutez avec nous",
          "LABEL": "Titre du Widget Bubble Launcher",
          "PLACE_HOLDER": "Discutez avec nous"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Mettre à jour les paramètres du Widget",
          "API": {
            "SUCCESS_MESSAGE": "Les paramètres du widget ont été mis à jour",
            "ERROR_MESSAGE": "Impossible de modifier les paramètres du widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Prévisualiser",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Gauche",
          "RIGHT": "Droite"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Bulle élargie"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Par défaut",
        "CHAT": "Discussion"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Répond généralement en quelques minutes",
        "IN_A_FEW_HOURS": "Répond généralement en quelques heures",
        "IN_A_DAY": "Répond généralement dans la journée"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Démarrer la conversation",
        "CHAT_INPUT_PLACEHOLDER": "Tapez votre message"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Nous sommes en ligne",
          "OFFLINE": "Nous sommes absents pour le moment"
        },
        "USER_MESSAGE": "Salut",
        "AGENT_MESSAGE": "Bonjour"
      },
      "BRANDING_TEXT": "Propulsé par JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Autres fournisseurs"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Site internet",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Courriel",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "PHONE": "Téléphone SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
